import { AxiosError } from "axios"

interface ErrorDetail {
  code?: string
  message?: string
}

/**
 * Extract our structured error code (e.g. "SEAT_LIMIT_REACHED", "ALREADY_MEMBER",
 * "LAST_ADMIN") from a 4xx response. The backend returns
 * ``detail: { code, message }`` for these cases.
 */
export function getTeamErrorCode(error: unknown): string | undefined {
  const axiosError = error as AxiosError<{ detail?: ErrorDetail | string }>
  const detail = axiosError?.response?.data?.detail
  if (detail && typeof detail === "object") {
    return detail.code
  }
  return undefined
}

export function getTeamErrorMessage(error: unknown): string | undefined {
  const axiosError = error as AxiosError<{ detail?: ErrorDetail | string }>
  const detail = axiosError?.response?.data?.detail
  if (typeof detail === "string") return detail
  if (detail && typeof detail === "object") return detail.message
  return undefined
}
